var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 66,
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4397_41579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1542 6.17607C58.0091 2.46915 54.0508 0.186523 49.768 0.186523H25.8183C21.5355 0.186523 17.5772 2.46915 15.4321 6.17608L3.47819 26.8328C1.32655 30.5509 1.32655 35.1356 3.47819 38.8537L15.4321 59.5104C17.5772 63.2174 21.5355 65.5 25.8183 65.5H49.768C54.0508 65.5 58.0091 63.2173 60.1542 59.5104L72.1081 38.8537C74.2598 35.1356 74.2598 30.5509 72.1081 26.8328L60.1542 6.17607Z",
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4397_41579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.993 48.3633H50.8906V51.1316H21.993V48.3633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3893 34.9815H33.8778C35.3121 34.9815 36.6241 34.9065 37.8186 34.7563C38.825 34.6296 39.7467 34.4466 40.5978 34.212C43.316 33.4425 45.2581 32.0912 46.6172 30.0736C48.3525 27.5023 48.4183 24.1944 46.8006 21.2196C46.1516 20.0325 44.6562 17.3017 43.5511 15.2841C43.4806 15.1621 43.4194 15.0448 43.3536 14.9275H52.1992V14.6648L38.6651 12.1592L39.7937 14.2096C39.7937 14.2096 43.2783 20.5533 44.3599 22.5428C45.4745 24.5932 45.4604 26.8267 44.3129 28.5252C42.5965 31.073 39.3752 32.2085 33.8778 32.2085H32.1754L40.6872 26.9721V23.7158L22.3893 34.9815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8231 32.8369H40.5977V49.7472H37.8231V32.8369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9021 14.4258L43.2454 15.2985L43.5511 15.2844L52.1992 14.9513V14.8621L42.9021 14.4258Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4397_41579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.5863,
    height: 65.3134,
    fill: "white",
    transform: "translate(0 0.186523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4397_41579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2003,
    height: 38.9725,
    fill: "white",
    transform: "matrix(-1 0 0 1 52.1992 12.1592)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.34f072a8ec168d3a149383f77169b20b.svg";
export { ForwardRef as ReactComponent };